module.exports = __webpack_public_path__ + "img/SES_4069004780.1230922f.jpg";